function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Notify } from 'quasar';
import { NotifyType } from '../const/notify-type.js';
export function useNotifyManager() {
  /**
   * Displays an error notification to the user.
   *
   * @param {string} message
   * @param {import('quasar').QNotifyUpdateOptions} [options={}]
   * @return {(props?: import('quasar').QNotifyUpdateOptions) => void}
   */
  function notifyError(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return notify(NotifyType.Error, message, options);
  }

  /**
   * Displays an info notification to the user.
   *
   * @param {string} message
   * @param {import('quasar').QNotifyUpdateOptions} [options={}]
   * @return {(props?: import('quasar').QNotifyUpdateOptions) => void}
   */
  function notifyInfo(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return notify(NotifyType.Info, message, options);
  }

  /**
   * Displays a success notification to the user.
   *
   * @param {string} message
   * @param {import('quasar').QNotifyUpdateOptions} [options={}]
   * @return {(props?: import('quasar').QNotifyUpdateOptions) => void}
   */
  function notifySuccess(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return notify(NotifyType.Success, message, options);
  }

  /**
   * Displays a warning notification to the user.
   *
   * @param {string} message
   * @param {import('quasar').QNotifyUpdateOptions} [options={}]
   * @return {(props?: import('quasar').QNotifyUpdateOptions) => void}
   */
  function notifyWarning(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return notify(NotifyType.Warning, message, options);
  }

  /**
   * Displays a notification to the user.
   *
   * @param {NotifyType} type
   * @param {string} message
   * @param {import('quasar').QNotifyUpdateOptions} [options={}]
   * @return {(props?: import('quasar').QNotifyUpdateOptions) => void}
   */
  function notify(type, message) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return Notify.create(_objectSpread({
      progress: true,
      type,
      message
    }, options));
  }
  return {
    notifyError,
    notifyInfo,
    notifySuccess,
    notifyWarning,
    notify
  };
}